import { CustomButton } from '@medtronic/pecc-react-component-library-js';
import { Alert, Stack, Typography } from '@mui/material';
import { Tooltip } from '~/components';
import { ProjectActionTypeEnum, useProjectActionState } from '~/hooks';
import { EmptyScheduledJobsIcon } from '~/icons';
import { useAppDispatch } from '~/redux';
import { ModalTypesEnum, openModal } from '~/redux/slices/modalSlice';
import { noETLJobsToDisplayStyles } from './styles';

const EmptyScheduledJobs = () => {
  const dispatch = useAppDispatch();
  const { isDisabledAction, tooltipMessage } = useProjectActionState({
    actionType: ProjectActionTypeEnum.ETL_JOB,
  });

  return (
    <Stack alignItems="center" justifyContent="center" spacing={3}>
      <EmptyScheduledJobsIcon />
      <Typography variant="headingMAlt" sx={noETLJobsToDisplayStyles}>
        No ETL Jobs to display
      </Typography>
      {!isDisabledAction && (
        <Typography>
          Click <strong>"Schedule"</strong> to get started.
        </Typography>
      )}
      <Tooltip title={tooltipMessage}>
        <CustomButton
          onClick={() => dispatch(openModal({ type: ModalTypesEnum.ETL_SCHEDULE_JOB }))}
          buttonType="addNew"
          label="Schedule"
          disabled={isDisabledAction}
        />
      </Tooltip>
      {isDisabledAction && <Alert severity="warning">{tooltipMessage}</Alert>}
    </Stack>
  );
};

export default EmptyScheduledJobs;
